var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9974,
    cy: 25,
    r: 19.8333,
    stroke: "url(#paint0_linear_2750_31127)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9948 14.5834C25.3401 14.5834 25.6713 14.7206 25.9155 14.9647C26.1597 15.2089 26.2969 15.5401 26.2969 15.8855V23.698H34.1094C34.4547 23.698 34.7859 23.8351 35.0301 24.0793C35.2743 24.3235 35.4115 24.6547 35.4115 25C35.4115 25.3454 35.2743 25.6766 35.0301 25.9208C34.7859 26.1649 34.4547 26.3021 34.1094 26.3021H26.2969V34.1146C26.2969 34.46 26.1597 34.7912 25.9155 35.0353C25.6713 35.2795 25.3401 35.4167 24.9948 35.4167C24.6495 35.4167 24.3183 35.2795 24.0741 35.0353C23.8299 34.7912 23.6927 34.46 23.6927 34.1146V26.3021H15.8802C15.5349 26.3021 15.2037 26.1649 14.9595 25.9208C14.7153 25.6766 14.5781 25.3454 14.5781 25C14.5781 24.6547 14.7153 24.3235 14.9595 24.0793C15.2037 23.8351 15.5349 23.698 15.8802 23.698H23.6927V15.8855C23.6927 15.5401 23.8299 15.2089 24.0741 14.9647C24.3183 14.7206 24.6495 14.5834 24.9948 14.5834Z",
    fill: "url(#paint1_linear_2750_31127)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2750_31127",
    x1: 4.16406,
    y1: 25,
    x2: 45.8307,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3788F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A44CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2750_31127",
    x1: 14.5781,
    y1: 25,
    x2: 35.4115,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3788F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A44CA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusAlt);
export default __webpack_public_path__ + "static/media/plus-alt.634caef4.svg";
export { ForwardRef as ReactComponent };